/** A pseudo-random source, shaped like `Math.random` so it can substitute for it anywhere. */
export type RandomSource = () => number;

/**
 * mulberry32 — a small, fast, deterministic PRNG. Same seed always produces the
 * same sequence, which is what a "daily puzzle" (same level for everyone on a
 * given date) needs; `Math.random` can't be seeded at all.
 */
export function mulberry32(seed: number): RandomSource {
  let a = seed >>> 0;
  return function random(): number {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Hashes an arbitrary string (e.g. a date key like "2026-09-13") into a 32-bit seed. */
export function seedFromString(input: string): number {
  let h = 1779033703 ^ input.length;
  for (let i = 0; i < input.length; i++) {
    h = Math.imul(h ^ input.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return (h ^ (h >>> 16)) >>> 0;
}
